<div class="input-plus-minus">
  <button
    class="input-plus-minus__button input-plus-minus__button--minus eye-color"
    [class.disabled]="value <= min"
    (click)="decrement()"
    type="button"
    appLongPress
    (longPressing)="decrement()"
  >
    <fa-icon [icon]="faMinusCircle"></fa-icon>
  </button>
  <div class="form-control form-control--sm input-plus-minus__control">
    <input
      #input="ngModel"
      type="number"
      [(ngModel)]="value"
      [min]="min"
      [max]="max"
      number
    />
  </div>
  <button
    class="input-plus-minus__button input-plus-minus__button--plus eye-color"
    [class.disabled]="value >= max"
    (click)="increment()"
    type="button"
    appLongPress
    (longPressing)="increment()"
  >
    <fa-icon [icon]="faPlusCircle"></fa-icon>
  </button>
</div>
